import { ChangeDetectionStrategy, Component, computed, inject } from '@angular/core';
import { FormsModule } from '@angular/forms';

import { MAT_DIALOG_DATA, MatDialogClose, MatDialogRef } from '@angular/material/dialog';
import { MatIcon } from '@angular/material/icon';

import { MemberProfile } from '@lib/core/models/member.interface';
import { PersonalDoctorMetadata, PharmacologicalItemMetaData, PrescriptionItem, ServiceMetadata } from '@lib/prescriptions/data-access';

@Component({
  selector: 'prescriptions-guarantee-confirmation-modal',
  imports: [FormsModule, MatDialogClose, MatIcon],
  templateUrl: './guarantee-confirmation-modal.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class GuaranteeConfirmationModalComponent {
  private readonly data: {
    pharmacologicalTreatments: PrescriptionItem<PharmacologicalItemMetaData>[];
    personalDoctor?: PrescriptionItem<PersonalDoctorMetadata>;
    relatedSpecialists: PrescriptionItem<ServiceMetadata>[];
    laboratoryServices: PrescriptionItem<ServiceMetadata>[];
    instrumentalDiagnostics: PrescriptionItem<ServiceMetadata>[];
    clientProfileInfo: MemberProfile;
    age: number;
  } = inject(MAT_DIALOG_DATA);
  private dialogRef = inject(MatDialogRef<GuaranteeConfirmationModalComponent>);

  protected readonly clientProfileInfo: MemberProfile = this.data.clientProfileInfo;
  protected readonly age: number = this.data.age;

  protected readonly medications = computed<PrescriptionItem<PharmacologicalItemMetaData>[]>(() => {
    return this.data.pharmacologicalTreatments ?? [];
  });
  protected readonly personalDoctor = computed<PrescriptionItem<PersonalDoctorMetadata>>(() => {
    return this.data.personalDoctor ?? null;
  });
  protected readonly services = computed<PrescriptionItem<ServiceMetadata>[]>(() => {
    const medicalServicesArray: PrescriptionItem<ServiceMetadata>[] = [];

    if (this.data.relatedSpecialists) medicalServicesArray.push(...this.data.relatedSpecialists);
    if (this.data.instrumentalDiagnostics) medicalServicesArray.push(...this.data.instrumentalDiagnostics);
    if (this.data.laboratoryServices) medicalServicesArray.push(...this.data.laboratoryServices);

    return medicalServicesArray;
  });

  protected closeDialog(isConfirmed?: boolean): void {
    this.dialogRef.close(isConfirmed);
  }
}
